export const north_carlolina = {
  "37000": "North Carolina",
  "37001": "Alamance County",
  "37003": "Alexander County",
  "37005": "Alleghany County",
  "37007": "Anson County",
  "37009": "Ashe County",
  "37011": "Avery County",
  "37013": "Beaufort County",
  "37015": "Bertie County",
  "37017": "Bladen County",
  "37019": "Brunswick County",
  "37021": "Buncombe County",
  "37023": "Burke County",
  "37025": "Cabarrus County",
  "37027": "Caldwell County",
  "37029": "Camden County",
  "37031": "Carteret County",
  "37033": "Caswell County",
  "37035": "Catawba County",
  "37037": "Chatham County",
  "37039": "Cherokee County",
  "37041": "Chowan County",
  "37043": "Clay County",
  "37045": "Cleveland County",
  "37047": "Columbus County",
  "37049": "Craven County",
  "37051": "Cumberland County",
  "37053": "Currituck County",
  "37055": "Dare County",
  "37057": "Davidson County",
  "37059": "Davie County",
  "37061": "Duplin County",
  "37063": "Durham County",
  "37065": "Edgecombe County",
  "37067": "Forsyth County",
  "37069": "Franklin County",
  "37071": "Gaston County",
  "37073": "Gates County",
  "37075": "Graham County",
  "37077": "Granville County",
  "37079": "Greene County",
  "37081": "Guilford County",
  "37083": "Halifax County",
  "37085": "Harnett County",
  "37087": "Haywood County",
  "37089": "Henderson County",
  "37091": "Hertford County",
  "37093": "Hoke County",
  "37095": "Hyde County",
  "37097": "Iredell County",
  "37099": "Jackson County",
  "37101": "Johnston County",
  "37103": "Jones County",
  "37105": "Lee County",
  "37107": "Lenoir County",
  "37109": "Lincoln County",
  "37111": "McDowell County",
  "37113": "Macon County",
  "37115": "Madison County",
  "37117": "Martin County",
  "37119": "Mecklenburg County",
  "37121": "Mitchell County",
  "37123": "Montgomery County",
  "37125": "Moore County",
  "37127": "Nash County",
  "37129": "New Hanover County",
  "37131": "Northampton County",
  "37133": "Onslow County",
  "37135": "Orange County",
  "37137": "Pamlico County",
  "37139": "Pasquotank County",
  "37141": "Pender County",
  "37143": "Perquimans County",
  "37145": "Person County",
  "37147": "Pitt County",
  "37149": "Polk County",
  "37151": "Randolph County",
  "37153": "Richmond County",
  "37155": "Robeson County",
  "37157": "Rockingham County",
  "37159": "Rowan County",
  "37161": "Rutherford County",
  "37163": "Sampson County",
  "37165": "Scotland County",
  "37167": "Stanly County",
  "37169": "Stokes County",
  "37171": "Surry County",
  "37173": "Swain County",
  "37175": "Transylvania County",
  "37177": "Tyrrell County",
  "37179": "Union County",
  "37181": "Vance County",
  "37183": "Wake County",
  "37185": "Warren County",
  "37187": "Washington County",
  "37189": "Watauga County",
  "37191": "Wayne County",
  "37193": "Wilkes County",
  "37195": "Wilson County",
  "37197": "Yadkin County",
  "37199": "Yancey County",
};
